import { render, staticRenderFns } from "./UVPListing.vue?vue&type=template&id=3188b802"
import script from "./UVPListing.vue?vue&type=script&lang=js"
export * from "./UVPListing.vue?vue&type=script&lang=js"
import style0 from "./UVPListing.vue?vue&type=style&index=0&id=3188b802&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports